export const SET_FILTER = 'SET_FILTER';
export const SET_FILTER_SUCCESS = 'SET_FILTER_SUCCESS';
export const SET_FILTER_ERROR = 'SET_FILTER_ERROR';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const REMOVE_FILTER_SUCCESS = 'REMOVE_FILTER_SUCCESS';
export const REMOVE_FILTER_ERROR = 'REMOVE_FILTER_ERROR';